import React from 'react';
import styled from 'styled-components';
import { Points } from '@styles';

const ArrowLeft = ({ fill = '#FF5600' }) => (
  <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.5 10V0" stroke={fill} />
    <path d="M0 5L11 7L9.5 5L11 3L0 5Z" fill={fill} />
    <path d="M8 5H11" stroke={fill} />
  </svg>
);
const ArrowRight = ({ fill = '#FF5600' }) => (
  <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.5 10V0" stroke={fill} />
    <path d="M11 5L0 7L1.5 5L0 3L11 5Z" fill={fill} />
    <path d="M0 5H3" stroke={fill} />
  </svg>
);

export const Separator = ({ fill = '#FF5600' }) => {
  return (
    <View>
      <ArrowLeft fill={fill} />
      <Line fill={fill} />
      <ArrowRight fill={fill} />
    </View>
  );
};

const View = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 15px 0;

  @media ${Points.laptop_wide} {
    padding: 20px 0;
  }

  @media ${Points.fullhd} {
    padding: 25px 0;
  }
`;
const Line = styled.div`
  flex-grow: 1;
  height: 1px;
  background-color: ${({ fill }) => fill};
`;
